
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { UnsplashImage } from "../../../futurelayer/api/unsplash";
import { ImageControlAndInfo } from "@/futurelayer/images/types";
import { callImageService } from "@/futurelayer/api/image-bridge";
import { isUnsplashImage } from "@/futurelayer/images/dimensions";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    TextInput,
    NiceButton,
    Icon
  }
})
export default class FutureLayerImageBrowser extends Vue {
  @Prop({ default: null })
  imageControlData!: ImageControlAndInfo | null;

  searchKeyword = "";
  searchResults: UnsplashImage[] = [];
  isSearching = false;
  currentSearchTerm = "";

  get aiKeywords(): string[] {
    return this.imageControlData?.keywords || [];
  }

  get displayedImages(): UnsplashImage[] {
    if (this.searchResults.length > 0) {
      return this.searchResults;
    }
    return this.imageControlData?.searchResults || [];
  }

  mounted() {
    if (this.aiKeywords.length > 0) {
      this.searchKeyword = this.aiKeywords[0];
      this.currentSearchTerm = this.aiKeywords[0];
    }
  }

  useKeyword(keyword: string) {
    this.searchKeyword = keyword;
    this.searchImages();
  }

  async searchImages() {
    if (!this.searchKeyword.trim()) return;

    this.isSearching = true;
    this.currentSearchTerm = this.searchKeyword;

    try {
      const results = await callImageService({
        query: this.searchKeyword,
        page: 1,
        per_page: 12
      });
      this.searchResults = results;
    } catch (error) {
      console.error("Image search failed:", error);
      this.searchResults = [];
    } finally {
      this.isSearching = false;
    }
  }

  previewImage(image: UnsplashImage) {
    // Use the same URL that's displayed in the grid to avoid loading delay
    const previewUrl = image.urls.regular || "";
    this.$emit("image-previewed", previewUrl);
  }

  restoreOriginalImage() {
    this.$emit("image-restored");
  }

  selectImage(image: UnsplashImage) {
    this.$emit("image-selected", image);
  }

  getImageSource(image: UnsplashImage): string {
    return isUnsplashImage(image) ? "Unsplash" : "Pexels";
  }
}
